import { render, staticRenderFns } from "./ShippingOrder.vue?vue&type=template&id=31d31ffe&scoped=true&"
import script from "./ShippingOrder.vue?vue&type=script&lang=js&"
export * from "./ShippingOrder.vue?vue&type=script&lang=js&"
import style0 from "./ShippingOrder.vue?vue&type=style&index=0&id=31d31ffe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d31ffe",
  null
  
)

export default component.exports